import clsx from 'clsx'
import React from 'react'
import { StatusType } from '@flatsy/types/Status'
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import { Body1 } from '../../../MaterialUi/Typo/Body'
import theme from '../../../MuiTheme/theme'
import { useStyle } from './Style'
import { StatusInlineProps } from './Type'

export const StatusInline: React.FC<StatusInlineProps> = ({
  text,
  status,
  customIcon,
  large,
  blackTextColor,
}): React.ReactElement => {
  const classes = useStyle()

  const renderColorProps = (): string => {
    if (status === StatusType.SUCCESS) {
      return theme.palette.success.main
    }
    if (status === StatusType.WAITING) {
      return theme.palette.warning.main
    }
    if (status === StatusType.ERROR) {
      return theme.palette.error.main
    }
    if (status === StatusType.WARNING) {
      return theme.palette.primary.dark
    }
    return theme.palette.primary.dark
  }

  const color = renderColorProps()
  const style = {
    color,
  }
  const textStyle = {
    color: blackTextColor ? theme.palette.common.black : color,
  }

  const renderIcon = () => {
    if (customIcon) {
      return customIcon
    }

    if (status === StatusType.WARNING) {
      return <ReportProblemOutlinedIcon className={classes.StatusIcon} style={style} />
    }

    if (status === StatusType.WAITING) {
      return <HourglassEmptyOutlinedIcon className={classes.StatusIcon} style={style} />
    }

    if (status === StatusType.SUCCESS) {
      return <CheckCircleOutlineOutlinedIcon className={classes.StatusIcon} style={style} />
    }
    if (status === StatusType.ERROR) {
      return <CancelOutlinedIcon className={classes.StatusIcon} style={style} />
    }
  }

  return (
    <div className={clsx(classes.StatusInline)}>
      {renderIcon()}
      <Body1 className={clsx(classes.text, !large && classes.smallText)} style={textStyle}>
        {text}
      </Body1>
    </div>
  )
}

export default StatusInline
